import { axiosInstance } from "./config";

const mapTexts = data => {
    const parsedKeys = {
        finalMessage: data.final_message,
        cardTitle: data.card_title,
        description: data.description,
        image: data.image,
        linkCta: data.link_cta,
        stamp: data.stamp,
        stampIcons: data.stamp_icons,
        textCta: data.text_cta,
        title: data.title,
        isCallMeBackVisible: data.call_me_back,
    };

    return Object.keys(parsedKeys).reduce((prev, key) => {
        if (parsedKeys[key]) {
            prev[key] = parsedKeys[key];
        }
        return prev;
    }, {});
}

export const apiGetTexts = async () => {
    console.log('API - get test');
    try {
        let response = await axiosInstance({
            url: '/get-frontend-content',
            method: 'GET',
        });
        return mapTexts(response.data);
    } catch (error) {
        console.log('API - Error getting texts', error);
        throw (error);
    }
}